import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { RegisterVerifySent } from '@/features/auth/components/RegisterVerifySent';

export const Route = createFileRoute('/client_/register/sent')({
  component: Page,
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function Page() {
  return (
    <AuthLayout formSide="right" brandPanel={<ClientAuthBrandPanel />}>
      <RegisterVerifySent />
    </AuthLayout>
  );
}
